<template>
    <span :style="pillStyle" :class="['select-none', clickableClass]" class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium">
        <slot></slot>
    </span>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#f3f4f6' // default to gray-100
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pillStyle() {
            const textColor = this.getContrastYIQ(this.color) === 'black' ? '#1f2937' : '#ffffff'; // text-gray-800 or white
            return {
                backgroundColor: this.color,
                color: textColor
            };
        },
        clickableClass() {
            return this.clickable ? 'cursor-pointer' : '';
        }
    },
    methods: {
        getContrastYIQ(hexcolor) {
            hexcolor = hexcolor.replace('#', '');
            const r = parseInt(hexcolor.substr(0, 2), 16);
            const g = parseInt(hexcolor.substr(2, 2), 16);
            const b = parseInt(hexcolor.substr(4, 2), 16);
            const yiq = (r * 299 + g * 587 + b * 114) / 1000;
            return yiq >= 128 ? 'black' : 'white';
        }
    }
}
</script>